import { Typography } from "@mui/material";
import MDBox from "components/MDBox";

import FadeMenu from "./MenuVertical";
import { ICamiseta } from "interfaces/kitsCamiseta";
import { KITS_ACCENT } from "../kits-evento.theme";

interface CardCamisetasProps {
  item: ICamiseta;
  openModalAddEdit: (kit: ICamiseta | null) => void;
  updateEvento: () => void;
}

export default function CardCamisetas({
  item,
  updateEvento,
  openModalAddEdit,
}: CardCamisetasProps) {
  return (
    <MDBox
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      borderRadius="lg"
      height={108}
      width={108}
      sx={{
        border: "1px solid",
        borderColor: "grey.200",
        bgcolor: "background.paper",
        transition: "box-shadow 0.2s, border-color 0.2s",
        "&:hover": {
          borderColor: "rgba(249, 96, 48, 0.4)",
          boxShadow: "0 4px 12px rgba(249, 96, 48, 0.12)",
        },
      }}
    >
      <MDBox position="absolute" right={0} top={0}>
        <FadeMenu
          kit={item}
          updateEvento={updateEvento}
          openModalAddEdit={openModalAddEdit}
        />
      </MDBox>

      <Typography variant="h4" fontWeight={700} color={KITS_ACCENT}>
        {item.tamanho}
      </Typography>

      <MDBox
        position="absolute"
        bottom={10}
        display="flex"
        justifyContent="space-between"
        width="100%"
        px={1.25}
      >
        <Typography variant="caption" color="text.secondary">
          Qtd.
        </Typography>
        <Typography variant="caption" fontWeight={700}>
          {item.quantidade}
        </Typography>
      </MDBox>
    </MDBox>
  );
}
